<div class="dashboard-donut-graph">
    <canvas class="dashboard-donut-graph-chart" #canvas></canvas>
  </div>
  